import { z } from 'zod';
import { FlowDurationSchema } from '../../../duration/duration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
/**
 * This matches* WorkflowSignals here: https://github.com/VivaaHealth/vivaa/blob/53e01c71782f369f284482e3ecedc1b3faf0dc41/backend/primary/src/clients/flow/types.ts#L1
 * * Primary includes APPOINTMENT_SCHEDULED, but that's to drive the `WaitForAvailableSchedulingSlot` block which we don't support here, so it is omitted
 */
export var FlowFormCompletionWorkflowSignals;
(function (FlowFormCompletionWorkflowSignals) {
    //  Purposely omitting: AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
    FlowFormCompletionWorkflowSignals["FormSetCompleted"] = "FORM_SET_COMPLETED";
    FlowFormCompletionWorkflowSignals["FormSetExpired"] = "FORM_SET_EXPIRED";
    FlowFormCompletionWorkflowSignals["FormSetTerminal"] = "FORM_SET_TERMINAL";
})(FlowFormCompletionWorkflowSignals || (FlowFormCompletionWorkflowSignals = {}));
export const FlowWaitForFormCompletionBlockConfigSchema = z.object({
    signalName: z.enum(FlowFormCompletionWorkflowSignals),
    timeout: FlowDurationSchema,
});
export const FlowWaitForFormCompletionBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.WaitForFormCompletion),
    config: FlowWaitForFormCompletionBlockConfigSchema,
});
//# sourceMappingURL=config.js.map